module.exports = __webpack_public_path__ + "assets/img/connection_out_time.7fee96e9.png";